import { axiosInstance } from "@/axios/interceptors";
import { StatesSchema } from "@/features/states/schema";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";

export async function getStates(globalCountryId: number) {
	const response = await axiosInstance.get("/global/states", {
		params: {
			global_country_id: globalCountryId,
		},
	});
	const data = ZodSentryReporter.parse(StatesSchema, response);
	data.states.sort((a, b) => a.name.localeCompare(b.name));
	return data;
}
